export interface CaseClassificationInput {
  taxons: string[];
  estateTaxons: { taxonNamespace: string }[];
  estateNamespace: string;
}

export interface CaseLabelInput extends CaseClassificationInput {
  isActive: boolean;
  isSold: boolean;
  isJustSold: boolean;
  openhouses: { bookingRequired?: boolean }[];
  marketingTexts?: { label: string };
}

export function getCaseClassification(property: CaseClassificationInput) {
  return [
    ...property.taxons,
    ...property.estateTaxons.map((x) => x.taxonNamespace),
    property.estateNamespace,
  ];
}

export function isRental(list: string[]) {
  const rentalClassifications = ["dk.realequity.taxonomy.opdrag.udlejning"];
  return list.some((x) => rentalClassifications.includes(x));
}

function getAgreementSignedLabel(item: CaseLabelInput) {
  return isRental(getCaseClassification(item))
    ? "lejekontrakt underskrevet"
    : "købsaftale underskrevet";
}

export function getLabel(item: CaseLabelInput) {
  if (item.isJustSold) {
    return getAgreementSignedLabel(item);
  }

  if (!item.isActive && !item.isSold) {
    return "ikke på markedet";
  }

  if (isRental(getCaseClassification(item)) && item.isSold) {
    return "udlejet";
  }

  if (item.isSold) {
    return "solgt";
  }

  if (item.openhouses.find((x) => x.bookingRequired)) {
    return "åbent hus med tilmelding";
  }

  if (item.openhouses?.length > 0) {
    return "åbent hus";
  }

  if (item.marketingTexts?.label) {
    return item.marketingTexts?.label;
  }
}

const NEWS = /^(?:nyhed|ny|nyt|nye)(?![a-zæøå])|^åbent hus/i;

/** Whether a label's text announces something new (Nyhed, Ny pris, Åbent hus), not a status such as Solgt. */
export function announcesNews(label: unknown): boolean {
  return typeof label === "string" && NEWS.test(label.trim());
}

export function getCaseDetailSublabel(item: CaseLabelInput) {
  if (item.isJustSold) {
    return getAgreementSignedLabel(item);
  }

  if (!item.isActive && !item.isSold) {
    return "ikke på markedet";
  }

  if (isRental(getCaseClassification(item)) && item.isSold) {
    return "udlejet";
  }

  if (item.isSold) {
    return "solgt";
  }
}
